(ns ductile.ui.load-builder-v2.protocol
  (:require [cljs.reader :as reader]
            [clojure.string :as str]
            [ductile.ui.load-builder-v2.reducer :as lb2reducer]))

(defn enqueue-popup-op! [{:keys [ops-key sid now-ms]} op]
  (let [k (ops-key sid)
        raw (js/localStorage.getItem k)
        ops (if raw
              (or (reader/read-string raw) [])
              [])
        op' (merge {:id (str (random-uuid))
                    :ts (now-ms)}
                   op)]
    (js/localStorage.setItem k (pr-str (conj (vec ops) op')))))

(defn make-protocol
  [{:keys [popup-mode?
           sid
           window-id
           state
           dispatch!
           now-ms
           normalize-op
           normalize-message-type
           resolve-vehicle-id
           transport-id->wire
           vehicle-id->wire
           make-op-message
           post-message!
           post-op!
           ack-op!
           valid-message?
           push-trace!
           ops-key
           !applied-op-ids
           !applied-op-order
           !seen-message-ids
           !seen-message-order
           run-op!
           on-server-snapshot!]}]
  (let [mark-op-seen! (fn [op-id]
                        (when op-id
                          (let [seen (.-current !applied-op-ids)
                                order (.-current !applied-op-order)]
                            (if (contains? seen op-id)
                              false
                              (let [order' (conj order op-id)
                                    [seen' order''] (if (> (count order') 300)
                                                      (let [drop-id (first order')
                                                            rest-order (vec (subvec (vec order') 1))]
                                                        [(disj (conj seen op-id) drop-id) rest-order])
                                                      [(conj seen op-id) (vec order')])]
                                (set! (.-current !applied-op-ids) seen')
                                (set! (.-current !applied-op-order) order'')
                                true)))))
        resolve-transport-id (fn [raw-id]
                               (let [assignments (:transport->vehicle-ids @state)
                                     normalized-id (if (and (string? raw-id)
                                                            (str/starts-with? raw-id ":"))
                                                     (subs raw-id 1)
                                                     raw-id)
                                     as-keyword (when (string? normalized-id) (keyword normalized-id))
                                     as-uuid (when (string? normalized-id)
                                               (try
                                                 (uuid normalized-id)
                                                 (catch :default _ nil)))
                                     candidates (distinct [raw-id normalized-id as-keyword as-uuid])]
                                 (some #(when (contains? assignments %) %) candidates)))
        mark-message-seen! (fn [message-id]
                             (let [seen (.-current !seen-message-ids)
                                   order (.-current !seen-message-order)]
                               (if (contains? seen message-id)
                                 false
                                 (let [order' (conj order message-id)
                                       [seen' order''] (if (> (count order') 100)
                                                         (let [drop-id (first order')
                                                               rest-order (vec (subvec (vec order') 1))]
                                                           [(disj (conj seen message-id) drop-id) rest-order])
                                                         [(conj seen message-id) (vec order')])]
                                   (set! (.-current !seen-message-ids) seen')
                                   (set! (.-current !seen-message-order) order'')
                                   true))))
        run-shared-op! (fn [{:keys [op vehicle-ids transport-id name draft-id optimized-route? waypoint-order]}]
                         (let [op (normalize-op op)
                               transport-id (resolve-transport-id transport-id)
                               draft-id (cond
                                          (keyword? draft-id) draft-id
                                          (string? draft-id) (keyword (if (str/starts-with? draft-id ":")
                                                                        (subs draft-id 1)
                                                                        draft-id))
                                          :else draft-id)]
                           (run-op! {:op op
                                     :vehicle-ids vehicle-ids
                                     :transport-id transport-id
                                     :name name
                                     :draft-id draft-id
                                     :optimized-route? optimized-route?
                                     :waypoint-order waypoint-order})))
        apply-shared-op! (fn [{:keys [id] :as op-data}]
                           (if (and id (not (mark-op-seen! id)))
                             :duplicate
                             (run-shared-op! op-data)))
        optimistic-apply-op! (fn [op-data]
                               (run-shared-op! op-data))
        reconcile-from-shared! (fn []
                                 (when popup-mode?
                                   (doseq [op-data (sort-by :ts (vals (:pending-ops @state)))]
                                     (optimistic-apply-op! op-data))))
        submit-shared-op! (fn [op]
                            (if popup-mode?
                              (let [prepared-op (cond-> op
                                                  (#{:create-draft :create-draft-with-vehicles} (:op op))
                                                  (assoc :draft-id (or (:draft-id op)
                                                                       (lb2reducer/create-draft-id)))
                                                  true identity)
                                    op-id (str (random-uuid))
                                    payload (cond-> prepared-op
                                              (:transport-id prepared-op) (update :transport-id transport-id->wire)
                                              (:vehicle-ids prepared-op) (update :vehicle-ids #(mapv vehicle-id->wire %)))
                                    op-msg (make-op-message sid op-id (assoc payload :origin-window-id window-id))
                                    op-data (assoc prepared-op :id op-id :ts (now-ms))]
                                (optimistic-apply-op! op-data)
                                (push-trace! sid {:kind :submit-op
                                                  :where :popup
                                                  :window-id window-id
                                                  :op-id op-id
                                                  :op (:op prepared-op)})
                                (if (post-message! js/window.opener op-msg)
                                  (do
                                    (push-trace! sid {:kind :post-op
                                                      :where :popup
                                                      :window-id window-id
                                                      :ok? true
                                                      :op-id op-id})
                                    (dispatch! {:event :popup/pending-assoc
                                                :op-id op-id
                                                :op-data (assoc op-data :submitted-at (now-ms) :queued? false :acked-at nil)})
                                    {:op-id op-id :sent? true :queued? false})
                                  (do
                                    (push-trace! sid {:kind :post-op
                                                      :where :popup
                                                      :window-id window-id
                                                      :ok? false
                                                      :op-id op-id})
                                    (enqueue-popup-op! {:ops-key ops-key
                                                        :sid sid
                                                        :now-ms now-ms}
                                                       (assoc op-data :origin-window-id window-id))
                                    (push-trace! sid {:kind :queue-op
                                                      :where :popup
                                                      :window-id window-id
                                                      :op-id op-id
                                                      :op (:op prepared-op)})
                                    (dispatch! {:event :popup/pending-assoc
                                                :op-id op-id
                                                :op-data (assoc op-data :submitted-at (now-ms) :queued? true :acked-at nil)})
                                    {:op-id op-id :sent? false :queued? true})))
                              (let [prepared-op (cond-> op
                                                  (#{:create-draft :create-draft-with-vehicles} (:op op))
                                                  (assoc :draft-id (or (:draft-id op)
                                                                       (lb2reducer/create-draft-id)))
                                                  true identity)
                                    op-data (assoc prepared-op :id (str (random-uuid)) :ts (now-ms))]
                                (push-trace! sid {:kind :submit-op
                                                  :where :main
                                                  :window-id window-id
                                                  :op-id (:id op-data)
                                                  :op (:op prepared-op)})
                                (apply-shared-op! op-data)
                                (doseq [w (vals (:popouts @state))]
                                  (post-op! w sid (:id op-data)
                                            (cond-> (dissoc prepared-op :id :ts)
                                              (:transport-id prepared-op) (update :transport-id transport-id->wire)
                                              (:vehicle-ids prepared-op) (update :vehicle-ids #(mapv vehicle-id->wire %))
                                              true (assoc :origin-window-id window-id))))
                                {:op-id (:id op-data) :sent? true :queued? false})))
        handle-message! (fn [message source-window]
                          (when (and (valid-message? sid message)
                                     (mark-message-seen! (:id message)))
                            (let [payload (:payload message)
                                  type (normalize-message-type (:type message))]
                              (push-trace! sid {:kind :recv-msg
                                                :where (if popup-mode? :popup :main)
                                                :window-id window-id
                                                :msg-id (:id message)
                                                :type type
                                                :op (:op payload)})
                              (case type
                                :server/snapshot
                                (when on-server-snapshot!
                                  (on-server-snapshot! payload))

                                :op/apply (let [op-data (-> payload
                                                            (update :op normalize-op)
                                                            (update :transport-id resolve-transport-id)
                                                            (update :vehicle-ids (fn [ids]
                                                                                   (when (some? ids)
                                                                                     (mapv resolve-vehicle-id ids))))
                                                            (assoc :id (:id message))
                                                            (assoc :ts (:ts message)))]
                                            (try
                                              (if (and popup-mode? (contains? (:pending-ops @state) (:id message)))
                                                (do
                                                  (mark-op-seen! (:id message))
                                                  (dispatch! {:event :popup/pending-update
                                                              :op-id (:id message)
                                                              :f #(assoc % :acked-at (now-ms))}))
                                                (apply-shared-op! op-data))
                                              (push-trace! sid {:kind :apply-op
                                                                :where (if popup-mode? :popup :main)
                                                                :window-id window-id
                                                                :op-id (:id message)
                                                                :op (:op op-data)
                                                                :mode (if (and popup-mode? (contains? (:pending-ops @state) (:id message)))
                                                                        :ack-own
                                                                        :apply)})
                                              (when-not popup-mode?
                                                (doseq [w (vals (:popouts @state))]
                                                  (when (and w (not (identical? w source-window)))
                                                    (post-message! w message))))
                                              (when-not popup-mode?
                                                (ack-op! source-window sid (:id message) true nil))
                                              (catch :default e
                                                (push-trace! sid {:kind :apply-op-error
                                                                  :where (if popup-mode? :popup :main)
                                                                  :window-id window-id
                                                                  :op-id (:id message)
                                                                  :error (str e)})
                                                (when-not popup-mode?
                                                  (ack-op! source-window sid (:id message) false (str e))))))
                                :op/ack (when popup-mode?
                                          (let [{:keys [ok?]} payload]
                                            (push-trace! sid {:kind :ack-op
                                                              :where :popup
                                                              :window-id window-id
                                                              :op-id (:id message)
                                                              :ok? ok?})
                                            (if ok?
                                              (dispatch! {:event :popup/pending-update
                                                          :op-id (:id message)
                                                          :f #(assoc % :acked-at (now-ms))})
                                              (do
                                                (dispatch! {:event :popup/pending-dissoc
                                                            :op-id (:id message)})
                                                (reconcile-from-shared!)))))
                                nil))))]
    {:submit-shared-op! submit-shared-op!
     :handle-message! handle-message!
     :reconcile-from-shared! reconcile-from-shared!
     :apply-shared-op! apply-shared-op!}))
